module.exports = __webpack_public_path__ + "static/personal-solution-banner-7eb98d50fb11b4e13a878cd4ef3974f8.jpg";